<template>
	<div class="backgroundClass">
		<div class="newADcontent">
			<div class="adContent">
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
					<el-form-item label="券名称">
						<el-input v-model="addDataList.name" size="small" style="width: 500px;" maxlength="20"
							show-word-limit placeholder="输入优惠券名称，不能超过12个字"></el-input>
					</el-form-item>
					<el-form-item label="扫码领取情况">
						<div v-if="addDataList.scanUse!=null&&addDataList.scanTotal!=null" class="flex">
							使用数:{{addDataList.scanUse}} / 领取总数:{{addDataList.scanTotal}}
						</div>
						<div v-else>
							暂无
						</div>
					</el-form-item>
					<el-form-item label="券类型">
						<p style="width: 250px;">
							<el-radio v-model="addDataList.type" label="0">满减券</el-radio>
							<el-radio v-model="addDataList.type" label="1">折扣券</el-radio>
							<el-radio v-model="addDataList.type" label="2">商品券</el-radio>
							<el-radio v-model="addDataList.type" label="3">积分券</el-radio>
							<el-radio v-model="addDataList.type" label="4">第三方券</el-radio>
							<el-radio v-model="addDataList.type" label="5">膨胀券</el-radio>
						</p>
					</el-form-item>
					<el-form-item label="使用门槛" v-if="addDataList.type!=4">
						<p>
							<el-radio v-model="addDataList.thresholdType" label="0">无门槛使用</el-radio>
						</p>
						<p>
							<el-radio v-model="addDataList.thresholdType" label="1">
								满<el-input type="text" placeholder="请输入金额" v-model="addDataList.full"
									style="width: 150px;" size="small"></el-input>元使用
							</el-radio>
						</p>
					</el-form-item>
					<el-form-item label="不可用日期">
						<el-checkbox-group v-model="addDataList.disableDay" multiple="">
							<el-checkbox v-for="item in disableDayList" :label="item.id">{{item.name}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="不可用文本">
						<el-input v-model="addDataList.limitText" size="small" style="width: 500px;"></el-input>
					</el-form-item>
					<el-form-item label="适用范围" v-if="addDataList.type!=4">
						<p>
							<el-radio v-model="addDataList.trialScope" label="0">全部门店</el-radio>
							<!-- <el-radio v-model="addDataList.trialScope" label="1">直营门店</el-radio>
							<el-radio v-model="addDataList.trialScope" label="2">加盟门店</el-radio> -->
						</p>
						<p>
							<el-radio style="position: relative;" v-model="addDataList.trialScope" label="3">指定门店
							</el-radio>
							<span class="add" @click="addCoupons=true" v-if="addDataList.trialScope==3">
								<i class="el-icon-plus"></i>添加门店
							</span>
						</p>
						<div class="storelist" v-if="addDataList.trialScope==3">
							<ul>
								<li v-for="i in addDataList.storeList" :key="i">
									<p></p>{{zhuanmen(i)}}
									<div @click="storeclear(i)">×</div>
								</li>
							</ul>
						</div>
					</el-form-item>
					<el-form-item label="优惠内容" v-if="addDataList.type==0">
						<p>
							减<el-input type="number" placeholder="请输入金额" v-model="addDataList.reduction"
								style="width: 150px;" size="small"></el-input>元
						</p>
					</el-form-item>
					<el-form-item label="优惠内容" v-if="addDataList.type==1">
						<p>
							打<el-input type="number" placeholder="请输入折扣" v-model="addDataList.discount"
								style="width: 150px;" size="small"></el-input>折
						</p>
					</el-form-item>
					<el-form-item label="优惠内容" v-if="addDataList.type==2">
						<p>
							<el-radio v-model="addDataList.isGratis" label="0">免费领取</el-radio>
						</p>
						<p>
							<el-radio v-model="addDataList.isGratis" label="1">部分减免</el-radio>
						</p>
						<p v-if="addDataList.isGratis==1">减免<el-input size="small" type="number"
								style="width: 150px;margin-left: 5px;margin-right: 5px;" placeholder="请输入积分额度"
								v-model="addDataList.reductionIntegral"></el-input>积分</p>
						<p v-if="addDataList.isGratis==1">减免<el-input size="small" type="number"
								style="width: 150px;margin-left: 5px;margin-right: 5px;" placeholder="请输入金额"
								v-model="addDataList.reduction"></el-input>元</p>
					</el-form-item>
					<el-form-item label="优惠内容" v-if="addDataList.type==3   ">
						<p>
							赠送<el-input type="number" placeholder="请输入积分数量" v-model="addDataList.integralNum"
								style="width: 150px;" size="small"></el-input>积分
						</p>
					</el-form-item>
					<!-- 膨胀券 -->
					<el-form-item label="购买条件"
						v-if="addDataList.type==5 || addDataList.type==0 || addDataList.type==4 ">
						<p>
							<el-radio v-model="addDataList.buy" label="0">购买金额<el-input type="number"
									placeholder="请输入金额" :min="0" v-model="addDataList.buyNum" style="width: 150px;"
									size="small"></el-input>元</el-radio>
						</p>
						<p style="margin-top: 20px;">
							<el-radio v-model="addDataList.buy" label="1">兑换积分<el-input type="number"
									placeholder="请输入积分" v-model="addDataList.buyIntegralNum" style="width: 150px;"
									size="small"></el-input>积分</el-radio>
						</p>

						<!-- <p>
							购买金额<el-input type="number" :min="0" placeholder="请输入金额" v-model="addDataList.buyNum"
								style="width: 150px;" size="small"></el-input>元
						</p> -->
					</el-form-item>
					<!-- 接口	直接上架到积分商城 供客户使用积分兑换	 -->
					<el-form-item label="是否显示在积分商城">
						<el-radio-group v-model="addDataList.showPrice">
							<el-radio label="1">显示</el-radio>
							<el-radio label="0">不显示</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="是否显示优惠价格">
						<el-radio-group v-model="addDataList.showPrice">
							<el-radio label="1">显示</el-radio>
							<el-radio label="0">不显示</el-radio>
						</el-radio-group>
					</el-form-item>
					<!-- <el-form-item label="购买价格" v-if="addDataList.type==4">
						<p>
							<el-input type="number" placeholder="请输入金额" v-model="addDataList.reduction"
								style="width: 150px;" size="small"></el-input>元
						</p>
					</el-form-item> -->
					<el-form-item label="优惠内容" v-if="addDataList.type==5">
						<p>
							减<el-input type="number" placeholder="请输入金额" v-model="addDataList.reduction"
								style="width: 150px;" size="small"></el-input>元
						</p>
					</el-form-item>
					<el-form-item label="发行量">
						<el-input type="number" :disabled="$route.query.id != null" v-model="addDataList.totalNum"
							size="small" style="width: 200px;" placeholder="最多50000张"></el-input>
						<span>
							<el-button v-if="$route.query.id != null" type="text" @click="addQuan();"
								style="margin-left: 10px;">加券</el-button>
						</span>
						<div style="font-size: 12px;color: #999;">发行量只能增加不能减少，请谨慎设置</div>
					</el-form-item>
					<el-form-item label="适用商品" v-if="addDataList.type!=4">
						<p>
							<el-radio v-model="addDataList.trialProducts" label="1">全部剪发服务可用</el-radio>
							<!-- <el-radio v-model="addDataList.trialProducts" label="2">积分商城全部商品可用</el-radio> -->
						</p>
						<p>
							<el-radio style="position: relative;" v-model="addDataList.trialProducts" label="3">指定商品
								<div v-if="addDataList.trialProducts==3"
									style="position: absolute;left:40%;font-size:10px;color: #999B9C;">可多选</div>
							</el-radio>
							<span class="add" @click="addCoupons2=true" v-if="addDataList.trialProducts==3">
								<i class="el-icon-plus"></i>添加商品
							</span>
						</p>
						<div class="storelist" v-if="addDataList.trialProducts==3">
							<div style="display: flex;">
								<ul v-if="addDataList.serviceList.length>0">
									<div style="color: #0066CC;font-size:18px;">剪发服务</div>
									<li style="max-width: 200px;" v-for="(item,index) in addDataList.serviceList"
										:key="index">
										<p></p>{{zhuaser(item)}}
										<div @click="serviceclear(item)">×</div>
									</li>
								</ul>
								<ul v-if="addDataList.integralGoods.length>0">
									<div style="color: #0066CC;font-size:18px;">商城商品</div>
									<li style="max-width: 200px;" v-for="(item,index) in addDataList.integralGoods"
										:key="index">
										<p></p>{{zhuanshop(item)}}
										<div @click="shopclear(item)">×</div>
									</li>
								</ul>
								<ul v-if="addDataList.members.length>0">
									<div style="color: #0066CC;font-size:18px;">会员</div>
									<li style="max-width: 200px;" v-for="(item,index) in addDataList.members"
										:key="index">
										<p></p>{{zhuanmber(item)}}
										<div @click="membersclear(item)">×</div>
									</li>
								</ul>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="使用时间">
						<p>
							<el-radio v-model="addDataList.expiry" label="0">
								<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" size="small"
									v-model="addDataList.time" type="datetimerange" format="yyyy-MM-dd HH:mm:ss"
									range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</el-radio>
						</p>
						<p style="margin-top: 20px;">
							<el-radio v-model="addDataList.expiry" label="1">
								领取当日起
								<el-input v-model="addDataList.effectiveDays" type="number" size="small"
									style="width: 200px;" placeholder="填写天数"></el-input>
								天内可用
							</el-radio>
						</p>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">领取规则</div>
					</div>
					<el-form-item label="领取次数限制">
						<p>
							<el-radio v-model="addDataList.receiveLimit" label="0">不限次数，每人最多领取100张</el-radio>
						</p>
						<p style="margin-top: 20px;">
							<el-radio v-model="addDataList.receiveLimit" label="1">
								每人限领取
								<el-select style="width: 100px;margin:0 20px;" size="small" v-model="addDataList.num">
									<el-option v-for="item in countList" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								次
							</el-radio>
						</p>
					</el-form-item>
					<el-form-item label="活动叠加限制" v-if="addDataList.type!=4">
						<!-- <el-checkbox v-model="addDataList.superposition" label="1">优惠券仅原价购买商品时可用，不可与其他营销活动叠加使用
						</el-checkbox> -->
						<el-checkbox v-model="addDataList.superposition" label="1">可叠加
						</el-checkbox>
					</el-form-item>
					<el-form-item label="是否可转赠" v-if="addDataList.type!=4">
						<!-- <el-checkbox v-model="addDataList.superposition" label="1">优惠券仅原价购买商品时可用，不可与其他营销活动叠加使用
						</el-checkbox> -->
						<el-checkbox v-model="addDataList.give" label="1">可转赠
						</el-checkbox>
					</el-form-item>
          <el-form-item label="分销设置">
            <el-checkbox v-model="addDataList.isDistribution" label="1" :true-label="1" :false-label="0">可分销
            </el-checkbox>
          </el-form-item>
					<el-form-item label="第三方劵码" v-if="addDataList.type==4 && !$route.query.id">
						<div>
							<el-input type="textarea" v-model="codes" :autosize="{minRows:3,maxRows:18}"
								style="width:20%;"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="上传封面图">
						<div>
							<upload v-model="addDataList.imageSmall"  class="el-tabs-pane-upload"  ref="sss"
								style="width: 100px; height: 100px; margin-top: 10px; margin-left: 30px;" />
							<p style="font-size: 14px;color: #808080; margin-left: 30px;">点击上传小图片</p>
						</div>
					</el-form-item>
					<el-form-item label="使用规则">
						<quill-editor v-model="addDataList.rule" ref="myQuillEditor"
							style="height: 300px; width: 600px;">
						</quill-editor>
					</el-form-item>
					<!-- 、文字描述 -->
					<el-form-item label="文字描述" style="margin-top: 180px;">
						<el-input type="textarea" v-model="addDataList.remark" style="width: 600px;height: 300px;">
						</el-input>
					</el-form-item>
					<el-form-item label="备注" style="margin-top: 180px;">
						<el-input type="textarea" v-model="addDataList.remark" style="width: 600px;height: 300px;">
						</el-input>
					</el-form-item>
					<el-form-item align="center" style="margin-top: 80px;margin-bottom: 50px;">
						<el-button @click="goback">取消</el-button>
						<el-button type="primary" @click="add" style="margin-left: 20px;" :disabled="adding">保存
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- 添加门店 -->
		<el-dialog title="选择门店" :visible.sync="addCoupons" width="40%">
			<el-input v-model="filter.name" size="small" style="width: 200px;margin-top: -50px;" placeholder="输入门店名称">
			</el-input>
			<el-button type="primary" style="margin-left: 8px;" @click="getstorelist" size="small">搜索</el-button>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-table height="300" :data="dataList"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" style="width: 100%">
					<el-table-column align="center" width="100" label="选择">
						<template slot-scope="scope">
							<el-checkbox :label="scope.row.id" v-model="addDataList.storeList"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column label="城市" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.title">
								{{scope.row.title.split("-")[0]}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="店名" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.title">
								{{scope.row.title.split("-")[1]}}
							</span>
						</template>
					</el-table-column>
				</el-table>
				<div style="display: flex;margin-left: 80%;margin-top: 25px;">
					<el-button type="primary" size="small" @click='addCoupons=false'>确定</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加商品弹窗 -->
		<el-dialog title="添加商品" :visible.sync="addCoupons2" width="40%">
			<el-input v-model="filter3.name" size="small" style="width: 200px;margin-top: -50px;" laceholder="输入商品名称">
			</el-input>
			<el-button type="primary" @click="search" size="small" style="margin-left: 20px;">搜索</el-button>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-radio-group v-model="circulationcheck" style="margin-bottom: 30px;">
					<el-radio-button label="1">剪发服务</el-radio-button>
					<el-radio-button label="2">商城商品</el-radio-button>
					<el-radio-button label="3">会员</el-radio-button>
				</el-radio-group>
				<div v-if="circulationcheck==1">
					<el-table height="250" :data="harilist"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%;margin-top: -30px;">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id" v-model="addDataList.serviceList"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="title" label="名称"></el-table-column>
					</el-table>
				</div>
				<!-- 商城商品 -->
				<div v-if="circulationcheck==2">
					<el-table height="250" :data="shoplist"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%;margin-top: -30px;">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id" v-model="addDataList.integralGoods"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="title" label="名称"></el-table-column>
					</el-table>
				</div>
				<!-- 会员列表 -->
				<div v-if="circulationcheck==3">
					<el-table height="250" :data="memberlist"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%;margin-top: -30px;">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id" v-model="addDataList.members"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="title" label="名称"></el-table-column>
					</el-table>
				</div>
				<div style="display: flex; margin-left: 40%;margin-top: 25px;">
					<el-button type="primary" @click='addCoupons2=false' size="small">确定</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog v-if="$route.query.id != ''" :visible.sync="addDialog" title="加券" width="500px">
			<el-form inline label-position="left" label-width="90px" style="width: 250px;">
				<el-form-item label="领取数/总数">{{addDataList.getNum}} / {{addDataList.totalNum}} </el-form-item>
				<el-form-item v-if="addDataList.type != 4" label="增加数量">
					<el-input-number v-model="addDataList.totalNumAdd"></el-input-number>
				</el-form-item>
				<el-form-item v-if="addDataList.type == 4" label="第三方券码">
					<el-input type="textarea" v-model="codes" :autosize="{minRows:1,maxRows:18}"></el-input>
				</el-form-item>
			</el-form>
			<div class="mybotton">
				<el-button size="small" @click="addDialog=false">取消</el-button>
				<el-button type="primary" @click="add(1)" size="small">保存</el-button>
			</div>
		</el-dialog>

		<!-- <el-button @click="test()">test</el-button> -->
	</div>
</template>

<script>
	import upload from "../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				id: "",
				filter: {
					name: ""
				},
				codes: "",
				filter2: {
					name: ""
				},
				filter3: {
					name: ""
				},
				adding: false,
				checkstore: [], //选中门店
				circulationcheck: 1,
				addDataList: {
					name: "", //券名称
					type: "0", //券类型
					full: "", //满多少元试用
					buy: "0", //判断支付方式					
					buyNum: 0, //膨胀券多少元购买
					buyIntegralNum: 0, //多少积分购买
					buyInteg: 0, //膨胀券多少元购买
					showPrice: "", //优惠券是否显示价格
					reduction: "", //减多少钱
					discount: "", //打多少折
					integralNum: "", //赠送积分
					thresholdType: "0", //使用门槛
					totalNum: "", //发行量
					trialScope: "0", //适用范围
					storeList: [],
					trialProducts: "1", //适用商品
					receiveLimit: "0", //领取次数限制，0不限次数，1限制次数
					num: "", //限制的次数
					superposition: "", //活动叠加限制,0无,1有
					give: "", //是否可转赠,0否,1是
					expiry: "0", //判断使用时间
					effectiveDays: "",
					time: [], //自定义时间
					imageSmall: "", //封面图
					rule: "", //使用规则
					isGratis: "0", //免费领取或者部分领取
					reductionIntegral: "", //减免积分
					members: [], //会员
					integralGoods: [], //商城商品
					serviceList: [], //服务列表
					active: "",
					threshold: "", //券门槛
					circulation: "",
					dayCount: "",
					count: "",
					remark: "",
					totalNumAdd: 0, //增加券的数量
					disableDay: [],
					limitText: '',
          isDistribution: 0
				},
				originStartTime: '',
				originEndTime: '',
				countList: [{
					value: "1",
					label: "1"
				}, {
					value: "2",
					label: "2"
				}, {
					value: "3",
					label: "3"
				}],
				addCoupons: false, //判断是否显示使用范围弹出框
				addCoupons2: false, //判断是否显示适用商品弹出框
				dataState: "满减券",
				dataList: [], //门店列表
				storelist: [], //门店列表
				harilist: [],
				shoplist: [],
				memberlist: [],

				addDialog: false,
				disableDayList: [{
					id: "1",
					name: '周一'
				}, {
					id: "2",
					name: '周二'
				}, {
					id: "3",
					name: '周三'
				}, {
					id: "4",
					name: '周四'
				}, {
					id: "5",
					name: '周五'
				}, {
					id: "6",
					name: '周六'
				}, {
					id: "7",
					name: '周日'
				}, ]
			}
		},
		mounted() {
			// 获取
			this.getstorelist()
			// 获取剪发服务列表
			this.getservice()
			this.getshop()
			this.get3()
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.$http.get("dCoupon/getDCouponById?id=" + this.id).then(function(res) {
					if (res.body.code == 200) {
						var a = res.body.data
						var storeList = []
						if (a.storeList != 0 && a.storeList != '' && a.storeList != null) {
							storeList = a.storeList.split(",")
							for (let i in storeList) {
								storeList[i] = Number(storeList[i])
							}
						}
						//不可用日期
						if (a.disableDay == 0) {
							a.disableDay = []
						} else {
							if (a.disableDay != null) {
								if (a.disableDay.indexOf(",") != -1) {
									a.disableDay = a.disableDay.split(",")
								} else {
									var tmp = []
									tmp.push(a.disableDay)
									a.disableDay = tmp
								}
							}
						}
						if (a.disableDay == "") {
							a.disableDay = []
						}
						var timess = []
						if (a.startTime) {
							timess[0] = a.startTime
							timess[1] = a.endTime
						}
						this.originStartTime = a.startTime
						this.originEndTime = a.endTime
						var thres = a.thresholdType.toString()
						this.addDataList = {
							name: a.title, //券名称
							type: a.couponType ? a.couponType.toString() : "", //券类型
							full: a.full, //满多少元试用
							buy: a.buy, //判断支付方式
							buyNum: a.buyNum, //膨胀券多少元购买
							buyIntegralNum: a.buyIntegralNum, //多少积分购买
							getNum: a.getNum, //领取数
							showPrice: a.showPrice, //是否显示优惠价格
							reduction: a.reduction, //减多少钱
							discount: a.discount, //打多少折
							integralNum: a.integralNum, //赠送积分
							thresholdType: thres, //使用门槛
							totalNum: a.totalNum, //发行量
							trialScope: a.trialScope != null ? a.trialScope.toString() : "", //适用范围
							storeList: storeList,
							trialProducts: a.trialProducts != null ? a.trialProducts.toString() : "", //适用商品
							receiveLimit: a.receiveLimit != null ? a.receiveLimit.toString() : "", //领取次数限制，0不限次数，1限制次数
							num: "", //限制的次数
							superposition: a.superposition, //活动叠加限制,0无,1有
							give: a.give, //是否可转赠,0否,1是
							expiry: a.dateType != null ? a.dateType.toString() : "", //判断使用时间
							effectiveDays: a.sameDay,
							time: timess, //自定义时间
							imageSmall: a.imageSmall, //封面图
							rule: a.content, //使用规则
							isGratis: a.isGratis != null ? a.isGratis.toString() : "", //免费领取或者部分领取
							reductionIntegral: a.reductionIntegral, //减免积分
							members: a.membersLists ? a.membersLists : [], //会员
							integralGoods: a.integralGoodsLists ? a.integralGoodsLists : [], //商城商品
							serviceList: a.serviceLists ? a.serviceLists : [], //服务列表
							active: "",
							threshold: "", //券门槛
							circulation: "",
							dayCount: "",
							count: "",
							remark: a.remark,
							totalNumAdd: 0,
							scanUse: a.scanUse,
							scanTotal: a.scanTotal,
							disableDay: a.disableDay, //不可用日期
							limitText: a.limitText, //节假日不可用
              isDistribution: a.isDistribution
						}
						if (a.superposition != "0") this.addDataList.superposition = true
						if (a.give != "0") this.addDataList.give = true
						this.addDataList.time = timess
						if (a.receiveLimit != 0) this.addDataList.num = a.num
					}
				})
			}
		},
		computed: {
			// 转门店
			zhuanmen(i) {
				return (i) => {
					for (let a in this.dataList) {
						if (this.dataList[a].id == i) {
							return this.dataList[a].title
						}
					}
				}
			},
			zhuanshop(i) {
				return (i) => {
					for (let a in this.shoplist) {
						if (this.shoplist[a].id == i) {
							return this.shoplist[a].title
						}
					}
				}
			},
			zhuaser() {
				return (i) => {
					for (let a in this.harilist) {
						if (this.harilist[a].id == i) {
							return this.harilist[a].title
						}
					}
				}
			},
			zhuanmber() {
				return (i) => {
					for (let a in this.memberlist) {
						if (this.memberlist[a].id == i) {
							return this.memberlist[a].title
						}
					}
				}
			}
		},
		methods: {
			search() {
				if (this.circulationcheck == 1) {
					this.getservice()
				}
				if (this.circulationcheck == 2) {
					this.getshop()
				}
				if (this.circulationcheck == 3) {
					this.get3()
				}
			},
			// 获取剪发服务列表
			getservice() {
				this.$http.get("dCoupon/haircut?page=1&size=999999999&name=" + this.filter3.name).then(function(res) {
					if (res.body.code == "200") {
						this.harilist = res.body.data
					}
				})
			},
			getshop() {
				this.$http.get("dCoupon/shoppingMall?page=1&size=999999999&name=" + this.filter3.name).then(function(res) {
					if (res.body.code == "200") {
						this.shoplist = res.body.data
					}
				})
			},
			get3() {
				this.$http.get("dCoupon/member?page=1&size=999999999&name=" + this.filter3.name).then(function(res) {
					if (res.body.code == "200") {
						this.memberlist = res.body.data
					}
				})
			},
			add(type) {
				this.adding = true;
				var arr = {}
				if (this.$route.query.id) {
					arr.id = this.$route.query.id
				}
				if (!this.addDataList.name) {
					this.adding = false;
					this.$message.error("请输入优惠券名称")
					return false
				}
				arr.title = this.addDataList.name //优惠券名称
				arr.couponType = this.addDataList.type //优惠券类型
				arr.thresholdType = this.addDataList.thresholdType //使用门槛
        arr.isDistribution = this.addDataList.isDistribution
				if (arr.thresholdType == "1") {
					if (!this.addDataList.full) {
						this.adding = false;
						this.$message.error("请输入满多少元")
						return false
					}
					arr.full = this.addDataList.full
				}
				arr.trialScope = this.addDataList.trialScope //适用范围
				// 指定门店
				if (arr.trialScope == 3) {
					if (this.addDataList.storeList.length == 0) {
						this.adding = false;
						return this.$message.error("请选择门店")
					}
					arr.storeList = ""
					for (let i in this.addDataList.storeList) {
						if (i == 0) {
							arr.storeList += this.addDataList.storeList[i]
						} else {
							arr.storeList += "," + this.addDataList.storeList[i]
						}
					}
					arr.onlyStore = 1
				}
				// 满减减去的金额
				if (arr.couponType == 0) {
					if (!this.addDataList.reduction) {
						this.adding = false;
						this.$message.error("请输入减多少元")
						return false
					}
					arr.reduction = this.addDataList.reduction
				}
				if (arr.couponType == 1) {
					if (!this.addDataList.discount) {
						this.adding = false;
						this.$message.error("请输入多少折")
						return false
					}
					arr.discount = this.addDataList.discount
				}
				if (arr.couponType == 1) {
					if (!this.addDataList.discount) {
						this.adding = false;
						this.$message.error("请输入多少折")
						return false
					}
					arr.discount = this.addDataList.discount
				}
				if (arr.couponType == 2) {
					if (!this.addDataList.isGratis) {
						this.$message.error("请选择优惠内容")
						this.adding = false;
						return false
					}
					if (!this.addDataList.reductionIntegral) {
						this.adding = false;
						this.$message.error("请输入减免积分")
						return false
					}
					if (!this.addDataList.reduction) {
						this.adding = false;
						this.$message.error("请输入减免金额")
						return false
					}
					arr.isGratis = this.addDataList.isGratis
					arr.reduction = this.addDataList.reduction
					arr.reductionIntegral = this.addDataList.reductionIntegral
				}
				if (arr.couponType == 3) {
					if (!this.addDataList.integralNum) {
						this.adding = false;
						this.$message.error("请输入赠送积分")
						return false
					}
					arr.integralNum = this.addDataList.integralNum
				}
				// 膨胀券设置提醒
				if (arr.couponType == 5) {
					if (!this.addDataList.buyNum) {
						this.adding = false;
						return this.$message.error("请输入购买价格")
					}
					if (!this.addDataList.reduction) {
						this.adding = false;
						return this.$message.error("请输入优惠内容")
					}
					arr.buyNum = this.addDataList.buyNum;
					arr.reduction = this.addDataList.reduction;
				}
				if (!this.addDataList.totalNum && this.addDataList.type != 4) {
					this.adding = false;
					this.$message.error("请输入发行量")
					return false
				}
				if (type == 1) { //加券数量
					arr.totalNum = this.addDataList.totalNumAdd
				} else {
					arr.totalNum = this.addDataList.totalNum //发行量
				}
				arr.trialProducts = this.addDataList.trialProducts //适用商品
				if (this.addDataList.trialProducts == 3) {
					arr.serviceLists = this.addDataList.serviceList
					arr.integralGoodsLists = this.addDataList.integralGoods
					arr.membersLists = this.addDataList.members
					if (this.addDataList.serviceList.length == 0) {
						arr.serviceLists = []
						this.addDataList.trialProducts = '1'
						arr.trialProducts = '1'
					}
				}
				if (!this.addDataList.expiry) {
					this.adding = false;
					return this.$message.error("请选择使用时间")
				}
				arr.dateType = this.addDataList.expiry
				if (arr.dateType == 0) {
					if (!this.addDataList.time) {
						this.adding = false;
						return this.$message.error("请选择使用时间")
					}
					arr.startTime = this.addDataList.time[0]
					arr.endTime = this.addDataList.time[1]
				}
				if (arr.dateType == 1) {
					if (!this.addDataList.effectiveDays) {
						this.adding = false;
						return this.$message.error("请输入领取后的有效天数")
					}
					arr.sameDay = this.addDataList.effectiveDays
				}
				if (!this.addDataList.receiveLimit) {
					this.adding = false;
					return this.$message.error("请规定领取限制")
				}
				arr.receiveLimit = this.addDataList.receiveLimit
				if (this.addDataList.receiveLimit == 1) {
					if (!this.addDataList.num) {
						this.adding = false;
						return this.$message.error("请输入领取次数")
					}
					arr.num = this.addDataList.num
				}
				arr.superposition = 1
				if (!this.addDataList.superposition) {
					arr.superposition = 0
				}
				arr.give = 1
				if (!this.addDataList.give) {
					arr.give = 0
				}
				if (!this.addDataList.rule) {
					this.adding = false;
					return this.$message.error("请输入使用规则")
				}
				arr.rule = this.addDataList.rule
				if (arr.couponType == 4) {
					let temp = this.codes.split("\n").map(ele => ele = ele.trim());
					arr.codes = temp.toString();
					arr.totalNum = temp.length;
				}
				arr.showPrice = this.addDataList.showPrice;
				arr.trialScope = this.addDataList.trialScope;
				arr.remark = this.addDataList.remark;
				//不可用日期
				if (this.addDataList.disableDay != null) {
					if (this.addDataList.disableDay.indexOf(",")) {
						arr.disableDay = this.addDataList.disableDay.join(",");
					} else {
						arr.disableDay = this.addDataList.disableDay[0]; //只设置1天
					}
					if (this.addDataList.disableDay == "") {
						this.addDataList.disableDay = 0
					}
				} else {
					arr.disableDay = 0
				}
				if (this.addDataList.disableDay == "" || this.addDataList.disableDay.length == 0) {
					this.addDataList.disableDay = 0
				}
				if (this.addDataList.limitText != null) {
					arr.limitText = this.addDataList.limitText
				}
				if (type == 1) { //增加券
					arr.add = "1"
					this.$http.post("dCoupon/addNum", JSON.stringify(arr)).then(function(res) {
						if (res.body.code == "200") {
							if (this.$route.query.id) {
								this.$message.success("修改成功")
							} else {
								this.$message.success("添加成功")
							}
							this.cleanAddList()
							this.$router.go(-1)
						} else {
							this.adding = false;
							this.$message.error(res.body.msg)
						}
					})
				} else { //编辑券信息
					if (this.$route.query.id != null) {
						arr.add = "0" //不修改券码
					} else {
						arr.add = "1" //修改券码
					}
					if (this.originStartTime != arr.startTime || this.originEndTime != arr.endTime) {
						arr.changeTime = "1"
					}
					arr.buyNum = this.addDataList.buyNum
					this.$http.post("dCoupon/saveOrUpdate", JSON.stringify(arr)).then(function(res) {
						if (res.body.code == "200") {
							if (this.$route.query.id) {
								this.$message.success("修改成功")
							} else {
								this.$message.success("添加成功")
							}
							this.cleanAddList()
							this.$router.go(-1)
						} else {
							this.adding = false;
							this.$message.error(res.body.msg)
						}
					})
				}
				this.distinctCode()
			},
			distinctCode() { //查询是否有重复券码
				this.$http.get("dCoupon/distinctCode").then(res => {
					if (res.body.data != null) {
						var a = []
						res.body.data.forEach(item => {
							a.push(item.id)
						})
						this.$notify({
							title: '提示',
							message: '券id:' + a + '的券码重复',
							duration: 0
						});
					}
				})
			},
			cleanAddList() {
				this.addDataList = {
					name: "", //券名称
					type: "0", //券类型
					full: "", //满多少元试用
					buy: "0", //判断支付方式
					buyNum: "", //膨胀券购买金额
					buyIntegralNum: "", //购买使用积分
					reduction: "", //减多少钱
					discount: "", //打多少折
					integralNum: "", //赠送积分
					thresholdType: "0", //使用门槛
					totalNum: "", //发行量
					trialScope: "0", //适用范围
					storeList: [],
					trialProducts: "1", //适用商品
					receiveLimit: "", //领取次数限制，0不限次数，1限制次数
					num: "", //限制的次数
					superposition: "", //活动叠加限制,0无,1有
					give: "", //是否可转赠,0否,1是
					effectiveDays: "",
					time: "", //自定义时间
					rule: "", //使用规则
					members: [], //会员
					integralGoods: [], //商城商品
					serviceList: [], //服务列表
					active: "",
					threshold: "", //券门槛
					circulation: "",
					dayCount: "",
					count: "",
					showPrice: "",
					remark: "",
					totalNumAdd: 0,
					imageSmall: "",
          isDistribution: 0
				}
			},
			addQuan() {
				this.addDialog = true
			},
			goback() {
				this.$router.go(-1)
			},
			//弹出框的门店列表翻页
			pagechange(val) {
			},
			//获取门店列表
			getstorelist() {
				this.$http.get("store/list?page=1&size=9999&title=" + this.filter.name).then(function(res) {
					if (res.body.code == "200") {
						this.dataList = []
						res.body.data.rows.map(ele => {
							if (!ele.businessType) this.dataList.push(ele);
						})
					}
				})
			},
			//判断是否删除门店
			storeclear(i) {
				for (let j in this.addDataList.storeList) {
					if (this.addDataList.storeList[j] == i) {
						this.addDataList.storeList.splice(j, 1)
					}
				}
			},
			// 删除服务列表
			serviceclear(i) {
				for (let j in this.addDataList.serviceList) {
					if (this.addDataList.serviceList[j] == i) {
						this.addDataList.serviceList.splice(j, 1)
					}
				}
			},
			shopclear(i) {
				for (let j in this.addDataList.integralGoods) {
					if (this.addDataList.integralGoods[j] == i) {
						this.addDataList.integralGoods.splice(j, 1)
					}
				}
			},
			membersclear(i) {
				for (let j in this.addDataList.members) {
					if (this.addDataList.members[j] == i) {
						this.addDataList.members.splice(j, 1)
					}
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.backgroundClass {
		background-color: #f5f5f5;
	}

	.newADcontent {
		padding-left: 3vh;
		padding-top: 2vh;
	}

	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.storelist {
		ul {
			li {

				margin-top: 10px;
				line-height: 1.3;
				display: flex;
				width: auto;

				p {
					width: 8px;
					height: 8px;
					margin-right: 8px;
					border-radius: 50%;
					background-color: black;
					margin-top: 5px;
				}

				div {
					display: none;
					cursor: pointer;
					margin-left: 10px;
					width: 15px;
					height: 15px;
					background-color: red;
					color: white;
					border-radius: 50%;
					text-align: center;
					line-height: 15px;
				}

				&:hover {
					div {
						display: block;
					}
				}
			}
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}

	.add {
		border: 1px dashed #999B9C;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 3px;
		padding-bottom: 3px;
		cursor: pointer;
		color: #999B9C;
	}

	/deep/ .tabelContent .el-checkbox__label {
		display: none;
	}

	/deep/ .el-textarea__inner {
		height: 300px;
		background-color: transparent;
	}
</style>